import { render, staticRenderFns } from "./EntityItemForm.vue?vue&type=template&id=a4d3b67a&scoped=true"
import script from "./EntityItemForm.vue?vue&type=script&lang=js"
export * from "./EntityItemForm.vue?vue&type=script&lang=js"
import style0 from "./EntityItemForm.vue?vue&type=style&index=0&id=a4d3b67a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d3b67a",
  null
  
)

export default component.exports